export default __webpack_public_path__ + "static/media/v720.4f5e443a.m4v";